export default "__VITE_ASSET__BlNmPd8I__"